import { Spin } from 'antd'

import { IToogle } from './type'
import css from './index.module.scss'


export const Toogle = ({
    id,
    checked,
    isLoading = false,
    isDisabled = false,
    checkedContent = 'Да',
    uncheckedContent = 'Нет',
    onChange
}: IToogle) => {
    return <>
        <div className={css.container}>
            {isLoading && <div className={css.isLoading}><Spin size='small' styles={{ indicator: { color: 'var(--color_txt_accent)' } }} /></div>}

            <label className={css.toggle}>
                <input
                    id={id}
                    className={css.input}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    disabled={isDisabled}
                />

                <span className={css.track}>
                    <span className={`${css.state} ${css.stateOff}`}>
                        <span className={css.stateContent}>{uncheckedContent}</span>
                    </span>

                    <span className={`${css.state} ${css.stateOn}`}>
                        <span className={css.stateContent}>{checkedContent}</span>
                    </span>

                    <span className={css.thumb} />
                </span>
            </label>
        </div>
    </>
}